import { Grid, Skeleton, Stack, Card } from '@mui/material';
import React from 'react';

export default function LoadingList({ forwardRef }) {
  const NumberOfSkeletons = 3;
  return (
    <Card ref={forwardRef} elevation={0}>
      {Array.from(new Array(NumberOfSkeletons)).map((_, index) => (
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent={'space-between'}
          pt={1}
          pb={1}
          key={index}
        >
          <Stack direction="row" alignItems="center">
            <Grid item p={1}>
              <Skeleton variant="circular" width={20} height={20} />
            </Grid>
            <Grid item>
              <Grid container>
                <Grid item xs={12}>
                  <Skeleton width={71} height={9} />
                </Grid>
                <Grid item>
                  <Skeleton width={146} height={9} />
                </Grid>
              </Grid>
            </Grid>
          </Stack>
          <Grid item>
            <Skeleton variant="circular" width={20} height={20} />
          </Grid>
        </Grid>
      ))}
    </Card>
  );
}
